import {Modal} from "react-bootstrap";


export default function Carregando({ativo}) {

    return (
        <Modal open={ativo}>
            {/*<Loader size="large">*/}
            {/*    <h2>Carregando</h2>*/}
            {/*</Loader>*/}
        </Modal>
    );
}